export function setTitle(title?: string) {
  const base = 'ThreadLock™';
  document.title = title ? `${title} | ${base}` : base;
}
